const REGION_MANAGEMENT_CREDENTIALS = ['region_create', 'region_update', 'region_delete'];

export function hasRegionManagementRights(authenticatedUser) {
  const credentials = new Set(
    authenticatedUser?.user_role?.role_credential?.map((c) => c?.credential_id?.trim()) ?? [],
  );
  return REGION_MANAGEMENT_CREDENTIALS.some((id) => credentials.has(id));
}

/** Show region multi-select on user create/edit (not limited to assigned regions only). */
export function canSelectUserRegions(authenticatedUser) {
  return (
    (authenticatedUser?.user_region_ids?.length ?? 0) > 1 ||
    hasRegionManagementRights(authenticatedUser)
  );
}
